export enum MultiSelectType {
  DATE = 'DATE',
  USER_SHORT = 'USER_SHORT',
  OFFER_DATA = 'OFFER_DATA',
  CUSTOMER_DATA = 'CUSTOMER_DATA',
  FREE_TEXT = 'FREE_TEXT',
  OFFER_NUMBER = 'OFFER_NUMBER'
}

export enum MultiSelectValue {
  YY = 'YY',
  YYYY = 'YYYY',
  MMYYYY = 'MMYYYY',
  DDMMYYYY = 'DDMMYYYY',
  HHMMSS = 'HHMMSS',
  OFFER_NR = 'OFFER_NR',
  OBJECT_NR = 'OBJECT_NR',
  CUSTOMER_NAME = 'CUSTOMER_NAME',
  CUSTOMER_NR = 'CUSTOMER_NR'
}

export interface MultiSelectItem {
  value: MultiSelectValue | string;
  title: string;
}

export interface MultiSelectOption {
  title: string;
  type: MultiSelectType;
  items: MultiSelectItem[];
}
